import React, { useState } from 'react';
import { ReactComponent as AngleUp } from '../../assets/svg/AngleUp.svg';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Paragraph from './Paragraph';

function ListOfParagraphs({ paragraphs, setParagraphs, paragraphTextError, label = 'List of solution paragraphs' }: { paragraphs: any; setParagraphs: any; paragraphTextError: any; label?: string }) {
	const [showParagraphs, setShowParagraphs] = useState(true);

	const addNewParagraph = () => {
		setParagraphs((prev: any) => [...prev, { text: '', order: paragraphs.length + 1, type: 'TEXT' }]);
	};

	const handleDropParagraph = (droppedItem: any) => {
		// Ignore drop outside droppable container
		if (!droppedItem.destination) return;
		var updatedList = [...paragraphs];
		// Remove dragged item
		const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
		// Add dropped item
		updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
		// Update State
		let newReorderList = updatedList.map((item, index) => {
			return { ...item, order: index + 1, type: item?.type ?? 'TEXT' };
		});
		setParagraphs(newReorderList);
	};
	return (
		<div className='flex flex-col flex-1'>
			<div className='p-5 rounded-[10px] border border-primaryViolet'>
				<div className='flex flex-row items-center  mb-2 gap-4'>
					<p className='flex-1 text-left text-primaryViolet text-[20px] leading-6 font-semibold'>{label}</p>
					<div className={`${showParagraphs ? 'rotate-180' : 'rotate-0'} transition cursor-pointer h-9 w-9 flex items-center justify-center rounded-full border border-greyMedium`} onClick={() => setShowParagraphs(!showParagraphs)}>
						<AngleUp style={{ color: '#5E639B' }} />
					</div>
				</div>
				{showParagraphs && (
					<div>
						<DragDropContext onDragEnd={handleDropParagraph}>
							<Droppable droppableId='droppable'>
								{(provided, snapshot) => (
									<div ref={provided.innerRef} {...provided.droppableProps}>
										{paragraphs?.map((paragraph: any, index: number) => (
											<Draggable key={index.toString()} draggableId={index.toString()} index={index}>
												{(provided: any, snapshot) => <Paragraph provided={provided} paragraph={paragraph} index={index} paragraphs={paragraphs} setParagraphs={setParagraphs} paragraphTextError={paragraphTextError} />}
											</Draggable>
										))}
										{provided.placeholder}
										<div className='pointer mt-4 flex w-full items-center justify-center rounded-xl  bg-mudPurple py-4 text-[16px] left-5 font-semibold text-white hover:bg-deepPurple' onClick={() => addNewParagraph()}>
											Add pragraph {paragraphs?.length + 1}
										</div>
									</div>
								)}
							</Droppable>
						</DragDropContext>
					</div>
				)}
			</div>
		</div>
	);
}

export default ListOfParagraphs;
